import { ToastrService } from 'ngx-toastr';
import { TrocarEmpresaService } from './../../services/trocar-empresa.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BaseFormService } from 'src/app/services/base-form.service';
import {catchError, take} from 'rxjs/operators';
import { CompaniesByUser } from '@interfaces/wso2core/companies-by-user';
import { LoginService } from '@services/login.service';
import { Router } from '@angular/router';
import { DadosEmpresaService } from '@services/dados-empresa.service';
import { Company } from '@interfaces/wso2core/company';
import { AtributosService } from '@services/atributos.service';
import { ParametroSistemaService } from '@services/parametro-sistema.service';
import { of } from 'rxjs';
import { Wso2CoreService } from '@services/wso2-core.service';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import { AuthService } from '@services/auth.service';
import { WindowReferenceService } from '@services/window-reference.service';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { AlertTrocarEmpresaComponent } from '../../components/alert-trocar-empresa/alert-trocar-empresa.component';
import { HeaderSemMenuComponent } from '../../components/header-sem-menu/header-sem-menu.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';
import { CnpjPipe } from '../../pipes/cnpj.pipe';

@Component({
    selector: 'app-trocar-empresa',
    templateUrl: './trocar-empresa.component.html',
    styleUrls: ['./trocar-empresa.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, AlertTrocarEmpresaComponent, HeaderSemMenuComponent, BotaoChatComponent, FormsModule, NgClass, FooterComponent, CamelCasePipe, CnpjPipe]
})
export class TrocarEmpresaComponent extends BaseFormService implements OnInit {

  nomeEmpresaDestino: string;
  cnpjEmpresaDestino: string;
  companyIdDestino: number;
  idEmpresaLogada: number;
  titlePage: string;
  listaDeEmpresasFilter: CompaniesByUser[] = [];
  listaDeEmpresasOriginal: CompaniesByUser[] = [];
  ehTrocaDeEmpresa: boolean;
  cpfUsuarioLogado = sessionStorage.cpf;
  public showAlertTrocarEmpresa: boolean = false;
  public loadingGenerico: boolean = false;
  public termoDeBusca: string;

  constructor(private readonly trocarEmpresaService: TrocarEmpresaService,
    private readonly dadosEmpresaService: DadosEmpresaService,
    private readonly atributoService: AtributosService,
    private readonly parametroService: ParametroSistemaService,
    private readonly Toastr: ToastrService,
    private readonly router: Router,
    private readonly loginService: LoginService,
    private readonly auth: AuthService,
    private readonly wso2CoreService: Wso2CoreService,
    private readonly usuarioPermissaoService: UsuarioPermissaoService,
    private readonly windowRef: WindowReferenceService) {
      super();
  }

  ngOnInit(): void {
    this.idEmpresaLogada = Math.trunc(localStorage.idEmpresaLogada);
    this.ehTrocaDeEmpresa = this.idEmpresaLogada > 0;
    this.titlePage = this.ehTrocaDeEmpresa ? 'Alterar empresa' : 'Escolha a empresa para continuar';
    this.getCompaniesByUser();
    this.subjectParaTrocaDeEmpresa();
  }

  getCompaniesByUser() {
    this.loadingGenerico = true;
    this.trocarEmpresaService.getCompaniesByUser().pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.loadingGenerico = false;
        this.listaDeEmpresasOriginal = success == null ? [] : success.response.companies;
        this.listaDeEmpresasFilter = [...this.listaDeEmpresasOriginal];
        this.fluxoDeAcesso();
      },
      error: (error: any) => {
        this.loadingGenerico = false;
        this.Toastr.error('Erro ao fazer requisição');
        console.error(error);
      }
    });
  }

  fluxoDeAcesso(): void {
    LoginService.events$.next({type: 'login success'});
    if (this.ehTrocaDeEmpresa) {
      if (localStorage.empresaPai === "false") {
        let empresaPai = this.listaDeEmpresasFilter.find(
          x => x.subsidiaries.some(y => y.companyId === this.idEmpresaLogada)
        ).companyId;
          setTimeout(() =>
              this.abreFechaAccordion(`accordion${empresaPai}`, empresaPai, false)
            , 2000);
      }
    } else {
      let totalDeMatrizes = this.listaDeEmpresasFilter.length;
      if (totalDeMatrizes === 0) {
        this.router.navigate(['/sem-acesso']);
      }
      if (totalDeMatrizes === 1) {
        let company = this.listaDeEmpresasFilter[0];
        if (company.allowedOnParentCompany && company.subsidiaries.length === 0) {
          this.acessarEmpresa(company);
        } else if (!company.allowedOnParentCompany && company.subsidiaries.length === 1) {
          this.acessarEmpresa(company.subsidiaries[0]);
        } else {
          setTimeout(() => this.openAllAccordion(), 2000);
        }
      }
    }
  }

  openAllAccordion() {
    this.listaDeEmpresasFilter.forEach((item) => this.abreFechaAccordion(`accordion${item.companyId}`, item.companyId, false));
  }

  closeAllAccordion() {
    this.listaDeEmpresasFilter.forEach((item) => this.abreFechaAccordion(`accordion${item.companyId}`, item.companyId, true));
  }

  abreFechaAccordion(idAccordion: string, companyId: number, fechar: boolean = true) {
    if (document.getElementById(idAccordion) !== null) {
      const accordion = Array.from(document.getElementById(idAccordion).getElementsByClassName("subsidiarie"));
      const icone = document.getElementById(idAccordion).getElementsByClassName("icone")[0];
      accordion.forEach((element, i) => {
        if (element.classList.contains("d-none")) {
          element.classList.remove("d-none");
          icone.classList.remove("fa-angle-down");
          icone.classList.add("fa-angle-up");
          this.setCompanyExpanded(companyId, true);
        } else if (fechar) {
          element.classList.add('d-none');
          icone.classList.remove("fa-angle-up");
          icone.classList.add("fa-angle-down");
          this.setCompanyExpanded(companyId, false);
        }
      });
    }
  }

  setCompanyExpanded(companyId: number, status: boolean) {
    this.listaDeEmpresasFilter.filter(x => x.companyId === companyId).forEach(x => x.accordionOpened = status);
  }

  public subjectParaTrocaDeEmpresa(): void {
    this.trocarEmpresaService.subject.subscribe((success: any) => {
      this.idEmpresaLogada = success.idEmpresa;
      localStorage.clear();
      localStorage.setItem('idEmpresaLogada', String(success.idEmpresa));
      this.obtemInformacoesDaEmpresa(success.idEmpresa, success.cnpj);
    });
  }

  acessarMatriz(company: CompaniesByUser) {
    if (!company.allowedOnParentCompany) return;
    this.acessarEmpresa(company);
  }

  acessarEmpresa(company: Company) {
    if(this.ehTrocaDeEmpresa) {
      this.nomeEmpresaDestino = company.socialName;
      this.cnpjEmpresaDestino = company.cnpj;
      this.companyIdDestino = company.companyId;
      this.showAlertTrocarEmpresa = true;
    } else {
      this.trocarEmpresaService.subject.next({ cnpj: company.cnpj, idEmpresa: company.companyId, nomeEmpresa: company.socialName });
    }
  }

  isCurrentCompany(companyId: number): boolean {
    return this.idEmpresaLogada === companyId;
  }

  containsCurrentCompany(company: CompaniesByUser): boolean {
    if (!company.accordionOpened && company.subsidiaries.length > 0) {
      return company.subsidiaries.some(x => x.companyId == this.idEmpresaLogada);
    }
    return false;
  }

  public eventoAlertAlterarEmpresaFechou(event: any) {
    this.showAlertTrocarEmpresa = event;
  }

  obtemInformacoesDaEmpresa(idEmpresa: number, cnpj: string): void {
    this.loadingGenerico = true;
    this.consultaPrimeiroPedido(idEmpresa);

    this.dadosEmpresaService.getDadosEmpresa(String(idEmpresa)).pipe(take(1))
    .subscribe({
      next: (dados: any) => {
        if (dados.status === 'OK') {
          localStorage.setItem('cnpj', dados.response.cdCdcnpjEmp);
          localStorage.setItem('nomeEmpresa', dados.response.nmRazaosEmp);
          localStorage.setItem('nomeFantasia', dados.response.nmFantasEmp);
          localStorage.setItem('tipoPagamentoEmpresa', dados.response.dsMeipagMpg);
          localStorage.setItem('empresaPai', dados.response.empresaPai);
          sessionStorage.usuarioLogado = true;
        } else {
          localStorage.cnpj = cnpj;
        }
        this.verificaSeMantemUsuarioNoVT();
      },
      error: (erro: any) => {
        this.loginService.logout();
        console.error(erro);
      }
    });
  }

  consultaPrimeiroPedido(idEmpresa: number) {
    this.dadosEmpresaService.consultaPrimeiroPedido(idEmpresa).pipe(take(1))
    .subscribe({
      next: (response: any) => {
        const status = response.status === 'OK';
        localStorage.setItem('empresaNova', String(status));
      },
      error: (error: any) => console.error(error)
    });
  }

  verificaSeMantemUsuarioNoVT(): void {
    this.atributoService.getCompaniesAttributes('ACESSO SOMENTE AO PORTAL 2.0', this.idEmpresaLogada).pipe(take(1))
    .subscribe({
      next: (res: any) => res === null ? this.obtemUrlDoLegadoERedireciona() : this.obterIdDoCliente(),
      error: (_error: any) => this.obtemUrlDoLegadoERedireciona()
    });
  }

  obterIdDoCliente() {
    localStorage.acessaVT2 = true;
    this.wso2CoreService.findContactLevel().pipe(take(1))
    .subscribe({
      next: (dados: any) => {
        localStorage.setItem('apiUserId', dados.response.contactId);
        if (dados.response.isAdmin !== 'S') {
          const contactId = dados.response.contactId;
          localStorage.setItem('idCliente', contactId);
          this.equatePermission(contactId);
        }
        this.usuarioPermissaoService.carregarPermissoes();
        this.router.navigate(['/home']);
      },
      error: (error: any) => {
        console.error(error);
        this.Toastr.error(error.error.mensagem);
        this.loginService.logout();
      }
    });
    this.wso2CoreService.mergePermission().subscribe((success) => {
      this.usuarioPermissaoService.carregarPermissoes();
    });
  }

  obtemUrlDoLegadoERedireciona(): void {
    const dados$ = this.parametroService.getParametroSistema('URL_PORTAL_1_0');
    dados$.subscribe({
      next: (dados: any) => {
        this.auth.getAccessToken().then((token) => {
          const tokenBase64 = btoa(token);
          const url = `${dados.response}/callback.jsp?token=${tokenBase64}&idEmpresa=${this.idEmpresaLogada}`;
          this.windowRef.navigateTo(url);
        }).catch((error: any) => {
          console.error(error);
          this.Toastr.error('Falha ao obter token de acesso');
        });
      },
      error: () => this.Toastr.error('Falha ao obter os parâmetros do sistema')
    });
  }

  private equatePermission(idCliente: any) {
    if (idCliente) {
      this.wso2CoreService.equatePermission(idCliente)
        .pipe(catchError(err => {
          console.error('Ao equalizar as permissões do contato: ' + err);
          return of();
        })).subscribe();
    }
  }

  private normalizeCnpj(cnpj: string): string {
    if (!cnpj) return '';
    return cnpj
      .replace(/[.\-/\s]/g, '')
      .toUpperCase()
      .trim();
  }

  private matchesSearchTerm(company: any, searchTerm: string): boolean {
    if (!searchTerm) return true;

    const normalizedSearchTerm = this.normalizeCnpj(searchTerm);
    const normalizedCnpj = this.normalizeCnpj(company.cnpj);
    const normalizedName = company.socialName?.toUpperCase().trim() ?? '';

    return normalizedCnpj.includes(normalizedSearchTerm) ||
           normalizedName.includes(searchTerm.toUpperCase().trim());
  }

  private filterCompanies(): void {
    if (!this.termoDeBusca || this.termoDeBusca.trim().length === 0) {
      this.listaDeEmpresasFilter = [...this.listaDeEmpresasOriginal];
      return;
    }

    this.listaDeEmpresasFilter = this.listaDeEmpresasOriginal
      .map(company => {
        const companyMatches = this.matchesSearchTerm(company, this.termoDeBusca);

        const filteredSubsidiaries = company.subsidiaries.filter(sub =>
          this.matchesSearchTerm(sub, this.termoDeBusca)
        );

        if (companyMatches) {
          return { ...company };
        } else if (filteredSubsidiaries.length > 0) {
          return { ...company, subsidiaries: filteredSubsidiaries };
        }

        return null;
      })
      .filter(company => company !== null);
  }

  private expandAccordionsWithResults(): void {
    setTimeout(() => {
      this.listaDeEmpresasFilter.forEach(company => {
        const companyMatches = this.matchesSearchTerm(company, this.termoDeBusca);
        const hasMatchingSubsidiaries = company.subsidiaries.some(sub =>
          this.matchesSearchTerm(sub, this.termoDeBusca)
        );

        if ((companyMatches && company.subsidiaries.length > 0) ||
            (!companyMatches && hasMatchingSubsidiaries)) {
          this.abreFechaAccordion(`accordion${company.companyId}`, company.companyId, false);
        }
      });
    }, 100);
  }

  onTermoChange() {
    this.filterCompanies();

    if (this.termoDeBusca && this.termoDeBusca.trim().length > 0) {
      this.closeAllAccordion();
      this.expandAccordionsWithResults();
    } else {
      this.closeAllAccordion();
    }
  }
}
